import styled from 'styled-components'
import { getStepCircleStyles, StepStatus } from '../style'
import { StepperSize } from '../type'

interface StyledStepCircleProps {
    status: StepStatus
    size?: StepperSize
}

const StyledStepCircle = styled.div.withConfig({
    shouldForwardProp: (prop) => !['status', 'size'].includes(prop)
})<StyledStepCircleProps>(({ theme, status, size = 'md' }) =>
    getStepCircleStyles({ theme, status, size })
)

export default StyledStepCircle
